import { render, staticRenderFns } from "./Carteracirugia.vue?vue&type=template&id=199d834e"
import script from "./Carteracirugia.vue?vue&type=script&lang=js"
export * from "./Carteracirugia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports